import React from 'react';
import { Text } from 'v3/components';
import {
  AnswerContainer,
  AnswersContainer,
  QuestionItemHeader,
  SubQuestionContainer,
  VideoPreviewContainer,
} from './styles';

export function QuestionItem({ question }) {
  const questionTypeSlug = String(question?.type?.slug || '').toLowerCase();
  const isVideoVisualizationQuestion =
    questionTypeSlug === 'video_visualization';

  const media = question?.originalQuestion?.media || question?.media;
  const questionVideoUrl =
    media?.full_path || media?.fullPath || media?.url || '';

  return (
    <div>
      <QuestionItemHeader>
        <span>{question?.order ? `${question?.order}.` : ''}</span>
        <Text type="body" color="dark">
          {question?.question}
        </Text>
      </QuestionItemHeader>
      {isVideoVisualizationQuestion ? (
        <VideoPreviewContainer>
          {questionVideoUrl ? (
            <video
              controls
              style={{
                width: '100%',
                maxWidth: 560,
                maxHeight: 320,
                borderRadius: 8,
                border: '1px solid #E5E7EB',
              }}
            >
              <source src={questionVideoUrl} />
              <track kind="captions" />
            </video>
          ) : (
            <Text type="body" color="gray">
              Vídeo não disponível para visualização.
            </Text>
          )}
        </VideoPreviewContainer>
      ) : (
        <AnswersContainer>
          {question?.values?.map(answer => {
            return (
              <AnswerContainer key={answer?.id}>
                <Text type="body" color="dark">
                  {answer?.description}
                </Text>
              </AnswerContainer>
            );
          })}
        </AnswersContainer>
      )}
      {question?.subQuestion && (
        <SubQuestionContainer>
          <Text type="body" color="dark">
            {question?.subQuestion?.question}
          </Text>
          {question?.subQuestion?.values ? (
            <AnswersContainer>
              {question?.subQuestion?.values?.map((item) => {
                return (
                  <AnswerContainer>
                    <Text type="body" color="dark">
                      {item?.description}
                    </Text>
                  </AnswerContainer>
                );
              })}
            </AnswersContainer>
          ) : null}
        </SubQuestionContainer>
      )}
    </div>
  );
}
